import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function CostReportForm({ location }) {
  console.log('CostReportForm rendered: ', location)

  let init = {
    invoiceDateFrom: '',
    invoiceDateTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('CostReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  const [formFeedback, setFormFeedback] = useState({})

  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    console.log('userEffect: ', formFeedback, scrollRef)
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [formFeedback])

  async function submitSearch() {
    console.log('CostReportForm.submitSearch', inputs)
    setFormFeedback({})
    submitFormValues('CostReportForm', navigate, inputs, 'external_legal_cost.report')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText={'Wood External Legal Cost'} />
            {formFeedback.noInput}
            <tbody>
              <DateRangeInput label='Invoice Date' name='invoiceDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoiceDateFrom} defaultValueTo={inputs.invoiceDateTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}
